import { UserOrEmailMapping } from "../../features/Admin/typings/admin.types";
import { Colleague } from "../../features/Connections/types/Colleague.type";

export function getUserIdsOfUserOrEmailMapping(userOrEmailMapping: UserOrEmailMapping[]): string[] {
  return userOrEmailMapping.filter(user => user.userId).map(user => user.userId) as string[];
}

export function getEmailsOfUserOrEmailMapping(userOrEmailMapping: UserOrEmailMapping[]): string[] {
  return userOrEmailMapping
    .filter(user => !user.userId && user.email)
    .map(user => user.email) as string[];
}

/**
 * Returns a display label for a user or email mapping.
 * @param userOrEmailMapping - The user or email mapping object or string.
 * @param returnNameAndEmail - If true, includes the email in the label (if available).
 * @returns A string with the user's full name (and optionally email), or just the email.
 */
export const getOptionLabelOfUserOrEmailMapping = (
  userOrEmailMapping: UserOrEmailMapping | string,
  returnNameAndEmail: boolean = false
) => {
  if (typeof userOrEmailMapping === "string") return "";
  const { firstName, surname, email } = userOrEmailMapping;
  let label = firstName && surname ? firstName + " " + surname : "";

  // when user invites external visitors
  // email : Add "inputValue"
  if (surname === "external") return email || firstName || "";

  if (returnNameAndEmail && email && label.length > 0) {
    label += " (" + email + ")";
  }
  return label || email || "";
};

/**
 *Loop through all departmentusers, find them in the users array and add the
 *corresponding firstname and surname props to the departmentusers array
 */
export const enrichDepartmentusers = (
  departmentUsers: UserOrEmailMapping[],
  users: UserOrEmailMapping[]
) => {
  return departmentUsers.map(depUser => {
    const safeUsers = Array.isArray(users) ? users : [];
    const fullUser = safeUsers.find(u => String(u.userId) === String(depUser.userId));
    return {
      ...depUser,
      firstName: fullUser?.firstName,
      surname: fullUser?.surname
    };
  });
};

export const colleagueToUserEmailMapping = (colleagueArray: Partial<Colleague>[] | undefined) => {
  return (colleagueArray ?? []).map(col => {
    return {
      userId: col.userId,
      firstName: col.firstName,
      surname: col.surname,
      email: col.email,
      userMappingId: 0,
      companyId: col.companyId ?? 0,
      isRequired: false,
      external: false
    };
  });
};
